import React from "react";
import useStampytThreeSixtySpin from "../../../hooks/useStampytThreeSixtySpin";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import ModalBaseView from "../../../../shared-components/lexus/styles/organisms/Modal";
import Icon from "../../../../shared-components/lexus/styles/atoms/Icon";
import * as ModalStyles from "../../../../shared-components/lexus/styles/organisms/Modal.styles";
import * as Preloader from "../../../../../common-deprecated/styles/v2/lexus/custom/Preloader";
import type { UscThreeSixtySpinModalType } from "../../../utils/modalConstants";

const UscThreeSixtySpinModal = (props: ModalViewType<UscThreeSixtySpinModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { initialized, reference, token } = useStampytThreeSixtySpin();

    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            show={show}
            onClose={close}
            size="fillwindow"
            disableOutsideClick
        >
            <ModalStyles.Header>
                <ModalStyles.Button type="button" onClick={close}>
                    <Icon variant="close" />
                </ModalStyles.Button>
            </ModalStyles.Header>
            <ModalStyles.Body>
                {initialized && reference ? (
                    <stampyt-360
                        reference={reference}
                        token={token}
                        disable-gallery="true"
                        background-color="#000000"
                    />
                ) : (
                    <Preloader.PreLoaderWrapper>
                        <Preloader.default />
                    </Preloader.PreLoaderWrapper>
                )}
            </ModalStyles.Body>
        </ModalBaseView>
    );
};

export default UscThreeSixtySpinModal;
